export const SUMMARY_PRIMARY_TYPE = 'primary';
export const SUMMARY_SECONDARY_TYPE = 'secondary';

export const SUMMARY_TYPES = [SUMMARY_PRIMARY_TYPE, SUMMARY_SECONDARY_TYPE];
